import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import {
  AuthCloseIconImage,
  StyledAlertDialogContent,
  StyledAlertDialogOverlay,
} from '@/features/auth-managment/styles';
import {
  BonusDetails,
  BonusDialogContent,
  BurnWarningWrapper,
} from '@/flat-pages/bonuses/ui/styles';
import { Box } from '@/shared/ui/box/Box';
import BurnWarningIcon from '@/shared/assets/burn-warning.svg';
import {
  BodyTextBoldSecondary,
  BodyTextRegularSecondary,
  BoldHeadingQuaternary,
} from '@/shared/ui/typography';
import { Button } from '@/shared/ui/form/button';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { useScopedI18n } from '@locales/client';
import { useNotifications } from '@/shared/providers/notifications-provider/notifications-context';

export const NotAlowedModal = ({ visible, onOpen, onClose }) => {
  const { user } = useUser();
  const { notifications } = useNotifications();

  const t = useScopedI18n('common');
  return (
    <Dialog.Root open={visible} onOpenChange={onOpen}>
      <Dialog.Portal>
        <StyledAlertDialogOverlay onClick={() => onClose()} />
        <StyledAlertDialogContent>
          <BonusDialogContent>
            <Box $padding={16}>
              <BonusDetails>
                <Box onClick={onClose}>
                  <AuthCloseIconImage
                    width={32}
                    height={32}
                    src="/images/icons/close-dialog.svg"
                  />
                </Box>
                <Box $marginTop={24} $marginBottom={24}>
                  <BurnWarningWrapper>
                    <BurnWarningIcon />
                  </BurnWarningWrapper>
                </Box>
                <Box $textAlign="center">
                  <BoldHeadingQuaternary>
                    {t('game.bonus_block_2.title')}
                  </BoldHeadingQuaternary>
                </Box>
                <Box $textAlign="center" $marginTop={8} $marginBottom={12}>
                  <BodyTextRegularSecondary color="#AFAFAF">
                    {t('game.bonus_block_2.desc')}{' '}
                    {notifications?.bonus?.provider}
                  </BodyTextRegularSecondary>
                </Box>
                <Box></Box>

                <Box $marginTop={24} $display="flex" $gap={12}>
                  <Button
                    type="button"
                    onClick={() => onClose()}
                    fill
                    variant="secondary"
                  >
                    <Box $paddingTop={10} $paddingBottom={10}>
                      <BodyTextBoldSecondary>
                        {t('game.bonus_block_2.button_close')}
                      </BodyTextBoldSecondary>
                    </Box>
                  </Button>
                </Box>
              </BonusDetails>
            </Box>
          </BonusDialogContent>
        </StyledAlertDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
